// extracted by mini-css-extract-plugin
export default {"formContent":"UpdateKpiModal_formContent__bKOdt","measureItem":"UpdateKpiModal_measureItem__sTS+x"};